import React from 'react';
import { version } from '../../../package.json';

import {
  makeStyles,
  Drawer,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Hidden
} from '@material-ui/core';
import { 
  Notifications, Email, LockOpen, 
  Assignment, Apple,
  PlayArrow, FlagOutlined
} from '@material-ui/icons';
import { Link } from 'react-router-dom';
import AppConfig from "../../model/AppConfig";
import { useAppConfig } from "../../context/AppConfigContext";
import {
  home,
  contact,
  privacyPolicy,
  termsOfService,
  appStoreLink,
  playStoreLink,
  reportProblems
} from '../../routes/routes.json';

import drawerImg from '../../assets/static/FoodRecallsRoundedLogo.png';

const currentYear = new Date().getFullYear();

const useStyle = makeStyles((theme) => ({
  drawer: {
    [theme.breakpoints.up('md')]: {
      width: 320,
    },
    [theme.breakpoints.only('sm')]: {
      width: 260,
    },
    [theme.breakpoints.only('xs')]: {
      width: 240,
    },
    flexShrink: 0,
  },
  drawerContainer: {
    flexGrow: 1,
  },
  drawerPaper: {
    [theme.breakpoints.up('md')]: {
      width: 320,
    },
    [theme.breakpoints.only('sm')]: {
      width: 260,
    },
    [theme.breakpoints.only('xs')]: {
      width: 240,
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerImg: {
    [theme.breakpoints.up('md')]: {
      width: 85,
    },
    [theme.breakpoints.down('sm')]: {
      width: 70,
    },
    display: "none",
  },
  drawerImgContainer: {
    padding: 15,
    display: 'flex',
    justifyContent: 'space-between',
  },
  itemSpace: {
    marginBottom: 10,
  },
  link: {
    textDecoration: 'none',
    color: '#000',
  },
  list: {
    width: '100%',
  },
  drawerTitle: {
    textAlign: 'left',
    [theme.breakpoints.up('md')]: {
      marginTop: 20,
      fontSize: 25,
    },
    [theme.breakpoints.only('sm')]: {
      marginTop: 18,
      fontSize: 22,
    },
    [theme.breakpoints.only('xs')]: {
      marginTop: 15,
      fontSize: 20,
    },
  },
  licenseContainer: {
    paddingBottom: 16,
    paddingTop: 8,
  },
  copyright: {
    fontSize: 14,
  },
  version: {
    fontSize: 12,
  },
  flagLink: {
    display: "flex",
    alignItems: "center",
    textDecoration: 'none',
  },
  flagImg: {
    width: 24,
    height: 24,
    paddingTop: '18px',
    cursor: "pointer",
  },
}));

const handleNotificationsClick = () => {
  console.log('Notifications button clicked...');
  
  if (window.NativeAndroid) {
    let performNotificationClick = function() {
      window.NativeAndroid.performNotificationClick()
    };

    if (performNotificationClick) {
      console.log("Calling the click function interface from the javascript side...");
      performNotificationClick();
    }
  }
};

const DrawerItem = (props) => {
  const classes = useStyle();

  const { onClose, handleModalToggle } = props

  const { appConfigDict } = useAppConfig();
  const { country } = appConfigDict;

  const handleFlagTap = () => {
    props.onClose()
    handleModalToggle();
  };

  return (
    <Drawer
      className={classes.drawer}
      variant={props.variant}
      classes={{ paper: classes.drawerPaper }}
      anchor="right"
      open={props.open}
      onClose={onClose}
    >
      <Grid
        container
        alignItems="center"
        justify="space-between"
        className={classes.drawerImgContainer}
      >
        <Grid item display="flex">
          <Link to={home} onClick={onClose}>
            <img src={drawerImg} alt="Logo" className={classes.drawerImg} />
          </Link>
          <Link
            to={home}
            className={classes.link}
            onClick={onClose}
          >
            <Typography
              variant="h1"
              className={classes.drawerTitle}
            >
              Menu
            </Typography>
          </Link>
        </Grid>

        <Grid item>
          <IconButton className={classes.flagButton} onClick={handleFlagTap}>
            <img
              src={AppConfig.getFlagImg(country)}
              alt="Flag Icon"
              className={classes.flagImg}
            />
          </IconButton>
        </Grid>
      </Grid>
      <Divider className={classes.itemSpace} />
      <Grid container className={classes.drawerContainer}>
        <List component="nav" className={classes.list}>
          {/* <ListItem
            button
            className={classes.itemSpace}
            component={Link}
            to={search}
            onClick={onClose}
          >
            <ListItemIcon>
              <Search />
            </ListItemIcon>
            <ListItemText primary="Search" />
          </ListItem> */}
          {
            window.isMobileApp ?
          <ListItem
            button
            className={classes.itemSpace}
            onClick={handleNotificationsClick}
          >
            <ListItemIcon>
              <Notifications />
            </ListItemIcon>
            <ListItemText primary="Notifications" />
          </ListItem>
          : null
          }
          <a
            href={reportProblems}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
            onClick={onClose}
          >
          <ListItem
            button
            className={classes.itemSpace}
          >
            <ListItemIcon>
              <FlagOutlined />
            </ListItemIcon>
            <ListItemText primary="Report Illness" />
          </ListItem>
          </a>
          <Hidden smUp>
          {
            !window.isMobileApp ?
                <>
                <a
                  href={appStoreLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.link}
                  onClick={onClose}
                >
                  <ListItem
                    button
                    className={classes.itemSpace}
                  >
                    <ListItemIcon>
                      <Apple />
                    </ListItemIcon>
                    <ListItemText primary="iPhone App" />
                  </ListItem>
                </a>
                <a
                  href={playStoreLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.link}
                  onClick={onClose}
                >
                    <ListItem
                      button
                      className={classes.itemSpace}
                    >
                      <ListItemIcon>
                        <PlayArrow />
                      </ListItemIcon>
                      <ListItemText primary="Android App" />
                    </ListItem>
                  </a></>
                
              : null
          }
          </Hidden>
          <a
            href={privacyPolicy}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
            onClick={onClose}
          >
          <ListItem
            button
            className={classes.itemSpace}
          >
            <ListItemIcon>
              <LockOpen />
            </ListItemIcon>
            <ListItemText primary="Privacy Policy" />
          </ListItem>
          </a>
          <a
            href={termsOfService}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
            onClick={onClose}
          >
            <ListItem
              button
              className={classes.itemSpace}
            >
              <ListItemIcon>
                <Assignment />
              </ListItemIcon>
              <ListItemText primary="Terms of Use" />
            </ListItem>
          </a>
          <a
            href={contact}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
            onClick={onClose}
          >
          <ListItem
            button
            className={classes.itemSpace}
          >
            <ListItemIcon>
              <Email />
            </ListItemIcon>
            <ListItemText primary="Contact Us" />
          </ListItem>
          </a>
          {/* <a
            href={facebook}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
            onClick={onClose}
          >
            <ListItem
              button
              className={classes.itemSpace}
            >
              <ListItemIcon>
                <Facebook />
              </ListItemIcon>
              <ListItemText primary="Follow Us" />
            </ListItem>
          </a> */}
        </List>
      </Grid>
      <Divider className={classes.itemSpace} />
      <Grid container justify="center" className={classes.licenseContainer}>
        <div className={classes.link}>
          <Typography className={classes.copyright} variant="body1" color="initial" align="center">
            &copy; {currentYear} SmartAddress, Inc.
          </Typography>
          <Typography className={classes.version} variant="body1" color="initial" align="right">
            v{version}
          </Typography>
        </div>
      </Grid>
    </Drawer>
  );
};

export default DrawerItem;
